module.exports = __webpack_public_path__ + "static/media/B-homeowners.f471a63f.png";